import React, { useContext, useEffect, useRef, useState } from 'react'
import { ArrowLeft, Clipboard2Check, Clipboard2CheckFill, ClipboardCheck, Link } from 'react-bootstrap-icons'
import { NavLink } from 'react-router-dom'
import DateTimePickerFunctions from '../../../../components/ui/calendar/date_picket/DateTimePickerComponents/DateTimePickerFunctions'
import CommonFunctionsContext from '../../../common/CommonFunctionsProvider'
import DashboardContext from './DashboardProvider'
// import FlattenedHash from '../../../../libs/templating/FlattenedHash';
import FlattenedHash from '../../../../libs/templating/FlattenedHash'
import ToDoListLineItemPopup from '../../todo/components/ToDoListLineItemPopup'
import { ToDoListProvider } from '../../todo/ToDoListProvider'

const animateCSSTransition = (element, animation, element2, animation2, prefix = 'animate__') =>
  // We create a Promise and return it
  new Promise((resolve, reject) => {
    const animationName = `${prefix}${animation}`;
    const animationName2 = `${prefix}${animation2}`;
    // const node = document.querySelector(element);
    if (!(element && element2)) {
      resolve('Animation ended');
      return
    }
    const node = element;
    const node2 = element2;
    node.classList.remove(`d-none`);
    node.classList.add(`${prefix}animated`, animationName);
    node.classList.add(`animate__faster`);
    // When the animation ends, we clean the classes and resolve the Promise
    function handleAnimationEnd(event) {
      event.stopPropagation();
      node.classList.remove(`${prefix}animated`, animationName);
      node.classList.add(`d-none`);
      node2.classList.remove(`d-none`);
      node2.classList.add(`animate__faster`);
      node2.classList.add(`${prefix}animated`, animationName2);

      // node.classList.add(`d-none`);
      resolve('Animation ended');
    }


    node.addEventListener('animationend', handleAnimationEnd, { once: true });
  });
export default function DashboardWidgetToDo() {
  const { GlobalRef, helpRefs } = useContext(CommonFunctionsContext)
  const { results, setFilter, Queue } = useContext(DashboardContext)
  const [active, setActive] = useState()
  // const [loading, setLoading] = useState(true)
  const initilized = useRef(false)


  useEffect(() => {
    if (initilized.current) {
      if (typeof active === 'undefined') {
        setFilter('ToDoList', 'forDay', undefined)
        animateCSSTransition(helpRefs.current['DashboardToDoListGroupItems'].current, 'fadeOutUp', helpRefs.current['DashboardToDoListGroupBreakDown'].current, 'fadeInRight')
      } else {
        setFilter('ToDoList', 'forDay', active.key)
        animateCSSTransition(helpRefs.current['DashboardToDoListGroupBreakDown'].current, 'fadeOutUp', helpRefs.current['DashboardToDoListGroupItems'].current, 'fadeInRight')
      }
    }
    initilized.current = true
  }, [active])

  return (
    <div className={`col-lg-4 col-md-12 dashboard-card`} style={{ maxHeight: 'calc(50% - 0.5rem)', height: 'calc(50% - 0.5rem)' }}>
      <div className='text-center bg-secondary-container p-3 rounded h-100 d-flex flex-column'>
        <div className='flex-shrink-1'>
          <h3><Clipboard2CheckFill className='me-2' />To Do List</h3>
        </div>
        {
          <>
            <div style={{ overflowY: 'auto', overflowX: 'hidden' }} className='flex-grow-1 d-flex flex-column justify-content-start align-items-start '>
              <div ref={r => GlobalRef(r, 'DashboardToDoListNotice')} className='d-none align-self-center'></div>
              <ToDoListGroups counts={results.toDoList && results.toDoList.breakDown} active={active} setActive={setActive} results={results} />
            </div>
          </>
        }

        <div className='flex-shrink-1'>
          <NavLink
            tag={Link}
            to={'/Dashboard/todo'
            }
            className={'text-light m-1'}
            style={{ cursor: 'pointer' }}><button className='btn btn-sm'><Clipboard2Check className='me-2' />Go to my To Do list</button></NavLink>
        </div>
      </div>
    </div>
  )
}

const ToDoListGroups = ({ counts, active, setActive, results }) => {
  const { Queue } = useContext(DashboardContext)
  const { helpRefs, GlobalRef, createModal } = useContext(CommonFunctionsContext)

  const GROUPS = [
    {
      name: 'Items for today',
      key: 'today'
    },
    {
      name: 'On going Items',
      key: 'ongoing'
    },
    // {
    //   name: 'Up and Coming',
    //   key: 'coming'
    // },
  ]

  return (
    <>
      <div className='d-flex flex-grow-1 w-100 flex-column ' ref={r => GlobalRef(r, 'DashboardToDoListGroupBreakDown')}>
        {GROUPS.map(g => <button key={g.key} className='text-start d-flex w-100 btn mb-1 shadow ' onClick={e => setActive({ ...g })}>
          <div className='flex-grow-1 align-items-start'><ClipboardCheck /> {g.name}</div>
          <div className='d-flex justify-content-end'>{`${counts && counts[g.key] ? `${counts[g.key]} ${counts[g.key] === 1 ? 'Item' : 'Items'}` : ''}`} </div>
        </button>)}
      </div>
      <div style={{ overflow: 'hidden' }} className='d-none flex-grow-1 w-100 flex-column' ref={r => GlobalRef(r, 'DashboardToDoListGroupItems')}>
        <div className='d-flex flex-column h-100'>
          <div className='d-flex flex-column flex-shrink-1  bg-primary-section'>
            <div className='d-flex align-items-center'>
              <button className='btn btn-sm  bg-primary-button' onClick={e => setActive()}><ArrowLeft /> </button>
              {/* <div className='flex-grow-1 align-self-center'>{Queue.length > 0 ? 'Updating items list' : active && `${active.name}`}</div> */}
              <div className='flex-grow-1 align-self-center'>{active && `${active.name}`}</div>

            </div>
            {/* <div className='d-flex shadow'>
            <button onClick={e => setFilter('Messages', 'Status', 'Received')} className={`btn btn-xs w-100 ${filter('Messages', 'Status') === 'Received' ? 'selected' : 'inactive'}`}>
              {`${filter('Messages', 'Status') === 'Received' ? 'Showing' : 'Show'} Unread`}</button>
            <button onClick={e => setFilter('Messages', 'Status', 'All')} className={`btn btn-xs w-100 ${filter('Messages', 'Status') === 'All' ? 'selected' : 'inactive'}`}>
              {`${filter('Messages', 'Status') === 'All' ? 'Showing' : 'Show'} All`}</button>
          </div> */}
          </div>
          <div className=' flex-grow-1' style={{ overflow: 'auto', height: '100%', maxHeight: '100%' }}>
            {/* <MessagesForTheDay active={active} /> */}
            {/* {JSON.stringify(Object.keys(results.toDoList))} */}
            {/* {JSON.stringify(results.toDoList.forDay[0].assignment.id)} */}
            {results && results.toDoList && results.toDoList.forDay && results.toDoList.forDay.map(a => <ToDoListLineItem key={a.assignment.id} assignment={a} />)}
          </div>
        </div>
      </div>
    </>
  )
}

const ToDoListLineItem = ({ assignment }) => {
  const { helpRefs, GlobalRef, createModal } = useContext(CommonFunctionsContext)
  const Flatten = new FlattenedHash(assignment, 'Assignment', {
    'Assignment|status|dateTimeCreated': (s) => { return DateTimePickerFunctions.FancyHumanDT(new Date(s)) },
    // 'Message|receviedDate': (s) => { return DateTimePickerFunctions.LocalISO(new Date(s), 'h') }
  })
  /*
  [
    "Message|assignment|id",
    "Message|assignment|listItemGroup|id",
    "Message|assignment|listItemGroup|group",
    "Message|assignment|listItemGroup|lists|id",
    "Message|assignment|listItemGroup|lists|list",
    "Message|assignment|listItemGroup|lists|items|id",
    "Message|assignment|listItemGroup|lists|items|item",
    "Message|assignment|listItemGroup|lists|items|dateTimeCreated",
    "Message|assignment|listItemGroup|lists|items|isDeleted",
    "Message|assignment|listItemGroup|lists|items|isDefault",
    "Message|assignment|listItemGroup|lists|isDeleted",
    "Message|assignment|listItemGroup|isDeleted",
    "Message|assignment|created",
    "Message|status|id",
    "Message|status|item",
    "Message|status|dateTimeCreated",
    "Message|status|isDeleted",
    "Message|status|isDefault"
  ]*/
  return (<div className='bg-light text-dark m-1 shadow rounded p-1'>
    {/* <pre>
      ---------------
      {JSON.stringify(Object.keys(Flatten.GetResult()), '\t', 2)}
      ---------------
    </pre> */}
    <div>{assignment.assignment.listItemGroup &&
      <>
        <div>{assignment.assignment.listItemGroup.lists &&
          assignment.assignment.listItemGroup.lists.map(l =>
            <>
              <div
                onClick={e => createModal(
                  <ToDoListProvider>
                    <ToDoListLineItemPopup assignmentId={assignment.assignment.id}
                      // item={assignment.assignment}
                      item={{
                        taskItem: assignment.assignment.listItemGroup.lists[0]
                      }}
                    />
                  </ToDoListProvider>
                )}
                style={{ cursor: 'pointer' }}>
                <div key={l.id}>{assignment.assignment.listItemGroup.group} - {l.list}</div>
                <div>
                  <div dangerouslySetInnerHTML={{
                    __html:
                      Flatten.FromMustache(`
                      {{#Assignment|status|item}}
                      Last update was {{Assignment|status|dateTimeCreated}} : {{{.}}}
                      {{/Assignment|status|item}}
                      {{^Assignment|status|item}}
                      Has not been started
                      {{/Assignment|status|item}}
                      `)
                  }} />
                </div>
              </div>
              <div>
                <select className='form-control form-control-sm'>

                  <option></option>
                  {
                    l.items && l.items.filter(a => a.isDeleted === false).map(i =>
                      <option
                        selected={
                          (assignment.status && assignment.status.id === i.id) ||
                          (i.isDefault)
                        }
                      >{i.item}</option>)
                  }
                </select>
              </div>
            </>)
        }</div>
      </>



    }</div>
  </div>)
}